import React from "react";
import WelcomeBanner from "./welcome-banner";
import DataEcosystemSection from "./data-ecosystem";
import { UnifyProfilesSection, ExploreProfilesSection } from "./promo-sections";
import PerformanceMetricsSection from "./performance-metrics";
import UploadedDataOverviewSection from "./uploaded-data-overview";
import { ConnectedSourcesSection, ActivatedDestinationsSection } from "./channel-grid";

// Data Hub overview — UI only for now (static placeholder numbers matching
// the design), broken into one component per section so each piece can be
// wired to its own real data source later without touching the rest.
const CDPOverview: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-transparent">
      <div className=" px-4 sm:px-6 py-6 space-y-6">
        <WelcomeBanner />
        <DataEcosystemSection />
        <UnifyProfilesSection />
        <PerformanceMetricsSection />
        <ExploreProfilesSection />
        <UploadedDataOverviewSection />
        <ConnectedSourcesSection />
        <ActivatedDestinationsSection />
      </div>
    </div>
  );
};

export default CDPOverview;
